import React, {useEffect, useRef, useState} from "react";
import { ReactComponent as Spinner} from "../../../assets/icons/tube-spinner.svg";
import { ReactComponent as MagnifingGlass} from "../../../assets/icons/magnifying-glass.svg";
import './AutocompleteComponent.scss'

interface AutocompleteComponentProps {
    label: string,
    results: string[],
    onChange: (searchQuery: string) => void,
    onSelect: (selected: string) => void,
    minDigits?: number,
    maxResults?: number,
    labelClass?: string,
    inputClass?: string,
    containerClass?: string,
    queryDelay?: number
}

const AutocompleteComponent: React.FC<AutocompleteComponentProps> = (
    {
        label,
        results,
        onChange,
        onSelect,
        minDigits,
        maxResults,
        labelClass,
        inputClass,
        containerClass,
        queryDelay,
    }: AutocompleteComponentProps) => {

    const [value, setValue] = useState("")
    const [loading, setLoading] = useState(false)
    const [trimmedResults, setTrimmedResults] = useState<string[]>([])
    const [showSelectContainer, setShowSelectContainer] = useState(false)

    useEffect(() => {
        if (maxResults) {
            setTrimmedResults(results.slice(0, maxResults))
        } else {
            setTrimmedResults(results)
        }
    }, [results, maxResults, loading]);

    const valueRef = useRef(value);
    valueRef.current = value;

    const onValueChange = (query: string) => {
        setValue(query)
        const minDigitsForQuery = minDigits && minDigits > 3 ? minDigits : 3
        const delay = queryDelay && queryDelay > 0.5 ? queryDelay : 0.5
        if (query.length > minDigitsForQuery) {

            setShowSelectContainer(true)
            setTimeout(async function(searchQuery: string) {
                if (searchQuery === valueRef.current) {
                    setLoading(true)
                    await onChange(searchQuery)
                    setLoading(false)
                }
            }.bind(null, query), delay * 1000)
        }
    }

    const onValueSelect = (selected: string) => {
        setShowSelectContainer(false)
        setValue(selected )
        onSelect(selected)
    }

    return (
        <div className={`autocomplete-container ${containerClass}`}>
            <div
                className={`${labelClass ? labelClass: ''} font-sm input-label flex-start primary-color full-row`}>
                {label}
            </div>
            <input
                    type="text"
                    className={`${inputClass ? inputClass: ''} input primary-font-color autocomplete full-border-radius 
                    secondary-color-border font-md-plus`}
                    value={value}
                    onChange={(event) => onValueChange(event.target.value)}
            />
            {loading ? <div className={`autocomplete-loading-icon`}><Spinner/></div> :
                <div className={`autocomplete-loading-icon`}><MagnifingGlass/></div>}
            <div className={`select-container full-row bottom-border-radius primary-border ${showSelectContainer && results.length > 0 ? '' : 'hide'} width-full`} style={{height: `${trimmedResults.length * 45}px`}}>
                {trimmedResults.map(result => (
                    <div key={result} className={`select-row font-sm flex-start full-width`} onClick={() => onValueSelect(result)}>{result}</div>
                ))}
            </div>
        </div>
    )
}

export default AutocompleteComponent